import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const subscribeNewsletter = async (email, source = 'footer') => {
    try {
        const response = await axios.post(`${API_URL}/api/subscriber/subscribe`, {
            email,
            source
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            const errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
            throw new Error(errorMessage);
        } else if (error.request) {
            throw new Error('Network error. Please check your connection and try again.');
        } else {
            throw new Error('An unexpected error occurred. Please try again.');
        }
    }
};

export const unsubscribeNewsletter = async (email) => {
    try {
        const response = await axios.post(`${API_URL}/api/subscriber/unsubscribe`, { email });
        return response.data;
    } catch (error) {
        if (error.response) {
            const errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
            throw new Error(errorMessage);
        } else if (error.request) {
            throw new Error('Network error. Please check your connection and try again.');
        } else {
            throw new Error('An unexpected error occurred. Please try again.');
        }
    }
};
